import React from 'react'
import { Button, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import styles from './home.module.scss';

const HomeSoftware = () => {
    return (<>
        <Container className={styles.mainContainer}>
            <div>
                <h2 className="centerText mb-4">Free software puts the power of the AHRQ Quality Indicators in your hands</h2>
                <p className="centerText mb-4">AHRQ offers free software to help organizations easily use the AHRQ QIs to generate actionable information about the quality of care they provide. The evidence-based AHRQ QIs provide a standard, trusted approach to quality measurement to guide improvements in patient care</p>
                <Row>
                    <Col xs={12} md={6}>
                        <img className={styles.actionImages + ' ' + 'mb-4'} src="winqi.png" />
                    </Col>
                    <Col xs={12} md={6}>
                        <h4>Calculate Quality Indicators with our SAS and WinQI Software</h4>
                        <ul>
                            <li>Easily calculate quality of care events that might need further study</li>
                            <li>Leverage software for hospital inpatient administrative data</li>
                            <li>Make data readily available and inexpensive</li>
                            <li>Completely free and easy to use</li>
                        </ul>
                        <Link
                            className="btn btn-primary"
                            role="button"
                            to="/software/win_qi"
                        >
                            Get the WinQI Software
                        </Link>
                        <h5 className='mt-3'>Prefer to work in a SAS/STAT software package?</h5>
                        <h5><Link to="/software/sas_qi">Try our SAS QI Software</Link></h5>
                    </Col>
                </Row>
            </div>
        </Container>
    </>)
}

export default HomeSoftware;